// extracted by mini-css-extract-plugin
export default {"header":"ProductOrderHeader_header__Q55CT","step":"ProductOrderHeader_step__DbiZD","title":"ProductOrderHeader_title__ABvQW","description":"ProductOrderHeader_description__39bM-"};